import { isStrEmpty } from '@/utils/utils'
import axios from 'axios'
import axiosLib from 'axios'

const axiosAuth = axiosLib.create()

export function setToken(data) {
    localStorage.setItem('token', data)
}

export function getToken() {
    return localStorage.getItem('token')
}

export function deleteToken() {
    localStorage.removeItem('token')
}

export function setLanguage(data) {
    localStorage.setItem('language', data)
}

export function getLanguage() {
    return localStorage.getItem('language')
}

export function setDataLanguage(data) {
    localStorage.setItem('dataLanguage', data)
}

export function getDataLanguage() {
    return localStorage.getItem('dataLanguage')
}

export function deleteDataLanguage() {
    return localStorage.removeItem('dataLanguage')
}

export function setAccount(data) {
    localStorage.setItem('account', data)
}

export function getAccount() {
    return localStorage.getItem('account')
}

export function deleteAccount() {
    localStorage.removeItem('account')
}

export function setCurrency(data) {
    localStorage.setItem('currency', data)
}

export function getCurrency() {
    return localStorage.getItem('currency')
}

export function deleteCurrency() {
    localStorage.removeItem('currency')
}

export function setGameSlug(data) {
    localStorage.setItem('gameSlug', data)
}

export function getGameSlug() {
    return localStorage.getItem('gameSlug')
}

export function deleteGameSlug() {
    localStorage.removeItem('gameSlug')
}

export const getLocale = () => {
    return 'en'
}

axiosAuth.interceptors.request.use((request) => {
    request.headers['Content-Type'] = 'application/json'
    request.headers['Access-Control-Allow-Origin'] = '*'

    let language: string =  getLanguage() || ''
    if(!isStrEmpty(language)) {
        request.headers['lang'] = language
    }

    return request
})

axiosAuth.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        if (error.response && error.response.data) {
            return Promise.reject(error.response.data)
        }
        return Promise.reject(error.message)
    }
)

export default axiosAuth
